import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { ThfModule } from '@totvs/thf-ui';

import { ThfPageBackgroundModule } from '../thf-page-background/index';
import { ThfPageBlockedUserComponent } from './thf-page-blocked-user.component';
import { ThfPageBlockedUserContactsComponent } from './thf-page-blocked-user-contacts/thf-page-blocked-user-contacts.component';
import { ThfPageBlockedUserReasonComponent } from './thf-page-blocked-user-reason/thf-page-blocked-user-reason.component';

/**
 * @description
 *
 * MÃ³dulo do template do thf-page-blocked-user.
 */
@NgModule({
  imports: [
    CommonModule,
    RouterModule,

    ThfModule,
    ThfPageBackgroundModule,
  ],
  declarations: [
    ThfPageBlockedUserComponent,
    ThfPageBlockedUserContactsComponent,
    ThfPageBlockedUserReasonComponent,
  ],
  exports: [
    ThfPageBlockedUserComponent,
    ThfPageBlockedUserContactsComponent,
    ThfPageBlockedUserReasonComponent,
  ]
})
export class ThfPageBlockedUserModule { }
